module.exports = __webpack_public_path__ + "static/img/h11.e3d9526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Hridya/Hridya-pics/h11.jpg
// module id = ltwe
// module chunks = 0